<div class="flex flex-col items-center justify-center gap-10">
	<img src="/assets/images/no-match.avif" [alt]="text">
	<span class="uppercase text-4xl md:text-6xl w-8/12 text-center">{{ text }}</span>
</div>
